export enum Product {
  NonprofitPortal = 0,
  SupportPortal = 1
}
